module.exports = __webpack_public_path__ + "static/media/dante-malagrino.232b2b77.jpeg";